export default __webpack_public_path__ + "static/media/login-bg-39.99751609.jpg";